var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0643 6.39191H14.2622V5.60774C14.2622 5.27296 13.9937 5 13.6629 5C13.3328 5 13.0636 5.27296 13.0636 5.60774V6.39191H12.2629C11.9321 6.39191 11.6636 6.66487 11.6636 6.99965C11.6636 7.33443 11.9321 7.6074 12.2629 7.6074H13.0636V8.39226C13.0636 8.72704 13.3328 9 13.6629 9C13.9937 9 14.2622 8.72704 14.2622 8.39226V7.6074H15.0643C15.3944 7.6074 15.6636 7.33443 15.6636 6.99965C15.6636 6.66487 15.3944 6.39191 15.0643 6.39191Z",
    fill: "#136BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33154 10.0103C4.63436 10.0103 2.33154 10.4415 2.33154 12.1643C2.33154 13.8865 4.62035 14.3333 7.33154 14.3333C10.0281 14.3333 12.3315 13.902 12.3315 12.1792C12.3315 10.4563 10.0427 10.0103 7.33154 10.0103Z",
    fill: "#136BFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.33137 8.36931C9.16775 8.36931 10.6398 6.8783 10.6398 5.01825C10.6398 3.15819 9.16775 1.6665 7.33137 1.6665C5.49499 1.6665 4.02295 3.15819 4.02295 5.01825C4.02295 6.8783 5.49499 8.36931 7.33137 8.36931Z",
    fill: "#136BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default __webpack_public_path__ + "static/media/join.9704ee4bfc451aeb31387a0c21ca5fce.svg";
export { ForwardRef as ReactComponent };